import {artifactStore} from 'app/store/global';
import {ajaxError} from 'app/utils';
import InventoryItemInterface from 'app/interfaces/InventoryItemInterface';
import LootInterface from 'app/interfaces/LootInterface';
import SteamSkinInterface from 'app/interfaces/SteamSkinInterface';

export interface LootboxOpenResponse {
    extra_data?: LootInterface[]
    steam_skin?: SteamSkinInterface
    steam_trade?: SteamSkinInterface
    win_artifact?: InventoryItemInterface
}

export interface LootboxOpenParams {
    doneOpenHandler: (
        item: InventoryItemInterface,
        response: LootboxOpenResponse,
        params: LootboxOpenParams
    ) => void
    timeStart: number
    show_loading?: boolean
    quick?: boolean
}

export const lootboxUse = (
    artifact: InventoryItemInterface,
    params: LootboxOpenParams,
    continue_equipping = false
): void => {
    const {public_view} = artifact;
    const {doneOpenHandler, show_loading} = params;

    if (public_view) {
        return;
    }
    artifactStore
        .use(artifact, continue_equipping, show_loading)
        .fail(response => {
            ajaxError(response);
        })
        .done(response => doneOpenHandler(artifact, response as LootboxOpenResponse, params));
};
